import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgParagraphBlack = (props, ref) => (_jsx("svg", { width: 17, height: 12, viewBox: "0 0 17 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M12.3333 4.33333H1.5M15.6667 1H1.5M15.6667 7.66667H1.5M12.3333 11H1.5", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgParagraphBlack);
export default ForwardRef;
